const RULES = [
  ["Come si gioca", [
    "Crea un torneo privato o entra con il codice invito di un amico.",
    "Per ogni giornata della competizione compili la tua schedina con i pronostici sulle partite.",
    "Vince chi a fine stagione ha più punti in classifica.",
  ]],
  ["La schedina", [
    "Fissa: scegli l'esito secco della partita, 1 (vince la squadra di casa), X (pareggio) o 2 (vince la squadra ospite).",
    "Doppia: scegli due esiti insieme, 1X, X2 o 12. Rischi meno ma prendi meno punti.",
    "Risultato esatto (facoltativo): oltre a fissa o doppia puoi indovinare il punteggio preciso.",
    "Ogni torneo fissa un numero massimo di fisse, doppie ed esatti per giornata: fisse + doppie corrispondono alle partite della giornata (10 in Serie A, Premier e LaLiga, 9 in Bundesliga e Ligue 1).",
    "Con l'opzione \"Nessun limite\" (sempre attiva per Champions, Mondiali ed Europei) fisse e doppie sono libere: resta solo il limite dei risultati esatti.",
  ]],
  ["Consegna", [
    "Puoi consegnare e modificare la schedina fino a 5 minuti prima dell'inizio della prima partita della giornata.",
    "Da quel momento la consegna è chiusa per tutte le partite della giornata.",
    "Fino alla chiusura vedi solo la tua schedina. Dopo la chiusura tutti vedono le schedine di tutti.",
    "Se non hai ancora consegnato, ricevi un promemoria via email circa 3 ore prima della chiusura.",
  ]],
  ["Punteggi", [
    "Fissa indovinata: i punti fissa decisi dall'admin del torneo (da 1 a 3).",
    "Doppia indovinata: i punti doppia decisi dall'admin (da 0,5 a 3).",
    "Risultato esatto indovinato: punti extra (da 1 a 5), che si sommano a quelli di fissa o doppia.",
    "Bonus giornata: punti extra se indovini tutti i pronostici che hai consegnato in quella giornata.",
    "I punti di una giornata vengono calcolati alla fine dell'ultima partita della giornata.",
    "Se una partita viene rinviata, il calcolo della giornata resta sospeso fino al recupero.",
  ]],
  ["Torneo e admin", [
    "Chi crea il torneo ne è l'admin.",
    "Ogni torneo ha una giornata di inizio e una di fine: contano solo i punti di quelle giornate.",
    "I tornei pubblici sono aperti a tutti e gestiti da Social Betting: si entra senza codice invito.",
    "Chi entra a torneo già iniziato parte con i punti dell'ultimo in classifica in quel momento.",
    "L'admin può cambiare nome e regole solo prima che inizi la prima giornata del torneo.",
    "L'admin può aggiungere o togliere punti a un giocatore (rettifica), rimuovere un giocatore o eliminare il torneo.",
    "Gli altri giocatori possono uscire dal torneo in qualsiasi momento: i loro pronostici vengono cancellati.",
  ]],
];

export const FreeGameNotice = ({ className = "" }) => (
  <p className={`text-xs text-slate-400 ${className}`} data-testid="free-game-notice">
    Gioco gratuito a punti virtuali: non si scommette denaro, non ci sono premi in denaro e nessun pagamento.
  </p>
);

export const Regolamento = () => (
  <section className="space-y-6" data-testid="regolamento">
    <h2 className="font-display text-2xl sm:text-3xl font-extrabold uppercase tracking-tight">Regolamento</h2>
    <div className="card-surface border-emerald-500/40 p-5">
      <p className="text-sm text-emerald-300">
        Social Betting è un gioco gratuito a punti virtuali, come il fantacalcio. Non si scommette denaro, non ci sono vincite in denaro e nessun pagamento.
      </p>
    </div>
    <div className="grid md:grid-cols-2 gap-4">
      {RULES.map(([title, items]) => (
        <div key={title} className="card-surface p-6" data-testid={`rules-section-${title.toLowerCase().replace(/\s+/g, "-")}`}>
          <h3 className="font-display text-xl font-bold uppercase text-emerald-400 mb-3">{title}</h3>
          <ul className="space-y-2 text-sm text-slate-300 list-disc pl-5">
            {items.map((i) => <li key={i}>{i}</li>)}
          </ul>
        </div>
      ))}
    </div>
  </section>
);
